angular
  .module 'filters'
  .filter 'cents', ($filter) ->
    (amount, symbol) ->
      $filter('currency')(amount / 100, symbol)
